// extracted by mini-css-extract-plugin
export default {"button":"ToolButton_button__5xAGj"};